import React, { useContext, useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { LinkContext } from "../context/LinkContext";
import { AuthContext } from "../context/AuthContext";
import { db, serverTime } from "../Utils/firebase";
import { checkAnchor } from "../Utils/Validation";

function AddLink() {
  const { userAuth, setUserData, userData } = useContext(AuthContext);
  const { al } = useContext(LinkContext);
  const [site, setSite] = useState("");
  const [slug, setSlug] = useState("");
  const [empty, setEmpty] = useState(true);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mount, setMount] = useState(true);
  const [btnText, setBtnText] = useState("Add");

  const selector = useRef();

  /* FILTER SELECTION LIST */
  const selectionArray = userData.account.map((ac) => {
    return ac.site;
  });

  const availableList = al.filter((link) => {
    return !selectionArray.includes(link.site);
  });
  /* FILTER SELECTION LIST */

  const chooseLink = (e) => {
    setSite(e.target.value);
  };

  const inputSlug = (e) => {
    setSlug(e.target.value);
    checkEmpty();
  };

  const checkEmpty = () => {
    if (slug !== "") {
      setEmpty(false);
    } else {
      setEmpty(true);
    }
  };

  const setDefault = () => {
    selector.current.selectedIndex = "0";
  };

  const limitChar = (e) => {
    if (
      e.target.value.length > e.target.maxLength &&
      e.keyCode !== 46 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    }
    checkEmpty();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const checkSlug = checkAnchor(slug);
    if (slug !== "" && site !== "") {
      if (checkSlug === true) {
        setLoading(true);
        setError(null);
        setBtnText("Checking ...");
        const accountData = {
          id: uuidv4(),
          site: site.toString(),
          anchor: slug.trim().toString(),
          create_at: new Date(),
        };
        db.collection("user")
          .doc(userAuth.uid)
          .get()
          .then((doc) => {
            const accountNum = doc.data().account.length;
            const result = doc.data().account;
            if (accountNum < 5) {
              if (mount) {
                setBtnText("Adding ...");
              }
              db.collection("user")
                .doc(userAuth.uid)
                .update({
                  account: [accountData, ...result],
                  updateAt: serverTime,
                })
                .then(() => {
                  db.collection("user")
                    .doc(userAuth.uid)
                    .get()
                    .then((doc) => {
                      setUserData(doc.data());
                      if (mount) {
                        setLoading(false);
                        setBtnText("Add");
                        setSite("");
                        setSlug("");
                        setEmpty(true);
                        setDefault();
                      }
                    })
                    .catch((error) => {
                      if (mount) {
                        setError(error.code);
                        setLoading(false);
                        setBtnText("Add");
                      }
                    });
                })
                .catch((error) => {
                  if (mount) {
                    setError(error.code);
                    setLoading(false);
                    setBtnText("Add");
                  }
                });
            } else {
              if (mount) {
                setError("Maximum 5 Accounts");
                setLoading(false);
                setBtnText("Add");
              }
            }
          })
          .catch((error) => {
            if (mount) {
              setError(error.code);
              setLoading(false);
              setBtnText("Add");
            }
          });
      } else {
        setError("Anchor is not valid");
      }
    } else {
      setError("Data cannot be empty!");
    }
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <div className="add-account divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Add Account</h5>
        <p className="text">New</p>
      </div>
      <form className="link-form" onSubmit={handleSubmit}>
        <div className="grup-input">
          <label>
            <select
              className="custom-select-2"
              name="site"
              id="site"
              onChange={chooseLink}
              ref={selector}
            >
              <option value="">-- Choose Site --</option>
              {availableList.map((l) => (
                <option key={l.site} value={l.site}>
                  {l.site}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="grup-input">
          <label>
            <span className="text">Anchor :</span>
            <input
              type="text"
              className="input-1"
              name="about"
              id="about"
              placeholder="Username / Phone Number (62) / ID / Email etc"
              maxLength={120}
              onKeyDown={limitChar}
              onKeyUp={limitChar}
              onKeyPress={limitChar}
              onChange={inputSlug}
              disabled={loading}
              value={slug}
            />
          </label>
        </div>

        {empty ? (
          <button
            className="btn-in darktextColor textTitle disable"
            disabled={true}
          >
            Add
          </button>
        ) : (
          <button
            className={
              loading
                ? "btn-in darktextColor textTitle disable"
                : "btn-in darktextColor textTitle "
            }
            disabled={loading}
            type="submit"
          >
            {btnText}
          </button>
        )}
      </form>
      {error && <p className="error text">{error}</p>}
    </div>
  );
}

export default AddLink;
